import React from 'react';
import { useGLTF } from '@react-three/drei';
import * as THREE from 'three'

const Model = ({ url, scale, position, rotate }) => {
    const { scene } = useGLTF(url);

    return (
        <primitive
            object={scene}
            scale={scale}
            position={[position.x, position.y, position.z]}  // توجه به ترتیب موقعیت
            rotation={[rotate.x - 1.6, rotate.y, rotate.z]}
        />
    )
};

export default Model;
